<div nxRow>
    <div nxCol="12">
        <h4 nxHeadline="subsection-small"
            class="nx-font-weight-light bordered" translate>
            ma-insurance.travel.insured-persons
        </h4>
    </div>
</div>
<div nxRow>
    <div nxCol="12">
        <table nxTable>
            <thead>
                <tr nxTableRow>
                    <th nxHeaderCell>
                        {{ 'policy.employees.data.surname' | translate }}
                    </th>
                    <th nxHeaderCell>
                        {{ 'policy.employees.data.name' | translate }}
                    </th>
                    <th nxHeaderCell>
                        {{ 'policy.employees.data.birth-date' | translate }}
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr nxTableRow *ngFor="let insuredPerson of maInsurance.insuredPerson">
                    <td nxTableCell>{{insuredPerson.surname}}</td>
                    <td nxTableCell>{{insuredPerson.firstName}}</td>
                    <td nxTableCell>{{insuredPerson.dateOfBirth|dateFormat}}</td>
                </tr>
            </tbody>
        </table>
    </div>
</div>